import { APP_INIT_STATES } from '@/constants';

export default {
  authUser: null,
  appInitState: APP_INIT_STATES.IN_PROCESS,
};
